import { Component } from 'react'
import { connect } from 'react-redux'
import { selectFaqs, selectTutorials } from './selectors'

const GroupContentHOC = (WrappedComponent, options) => {
  class GroupContent extends Component {
    generateProps = () => ({ ...this.props })

    render() {
      return <WrappedComponent {...this.generateProps()} />
    }
  }

  const mapStateToProps = (state) => ({
    faqs: selectFaqs(state, options.stateName),
    tutorials: selectTutorials(state, options.stateName)
  })

  return connect(mapStateToProps)(GroupContent)
}

export default GroupContentHOC
